import React from 'react';
import classNames from 'classnames';

import './quote.scss';

export const Quote = ({ styleModifier, quote, role, author }) => (
  <blockquote className={classNames('blockquote', styleModifier)}>
    <div className="blockquote__quote">
      <span className="blockquote__text">{quote}</span>
    </div>
    {(author || role) && (
      <footer className="blockquote__footer">
        <cite>
          {author && (
            <span className="blockquote__author">
              <span className="h-offscreen">Autor:</span>
              {author}
            </span>
          )}
          {role && <span className="blockquote__function">{role}</span>}
        </cite>
      </footer>
    )}
  </blockquote>
);

export default Quote;
